export default __webpack_public_path__ + "static/create-offer-a650b7ef2c707eedfaec2c5d31f2274e.png";